<template>
 <div id="containerbar" class="containerbar authenticate-bg">
        <!-- Start Container -->
        <div class="container">
            <div class="auth-box login-box">
                <!-- Start row -->
                <div class="row no-gutters align-items-center justify-content-center">
                    <!-- Start col -->
                    <div class="col-md-6 col-lg-5">
                        <!-- Start Auth Box -->
                        <div class="auth-box-right">
                            <div class="card">
                                <div class="card-body">
                                    <form  @submit.prevent="attemptLogin" action="#">
                                        <div class="form-head">
                                            <a href="/" class="logo"><img src="assets/images/logo.svg" class="img-fluid" alt="logo"></a>
                                        </div>                                        
                                       
                                        <div class="form-group">
                                            <input type="text" class="form-control" id="username" placeholder="Inserisci il tuo username" v-model="user.username" required="">
                                        </div>
                                       
                                        <b-row v-if="errormessage!=''">
                                        <b-col cols="12" class="text-center alert alert-danger">
                                            {{errormessage}}
                                        </b-col>

                                    </b-row>   
                                    <b-row v-if="successmessage!=''">
                                        <b-col cols="12" class="text-center alert alert-success">
                                            {{successmessage}}
                                        </b-col>

                                    </b-row>                      
                                      <button type="submit" class="btn btn-success btn-lg btn-block font-18 mb-3">Recupera password</button>
                                       <router-link :to="{name:'route-login'}" class="text-weight-semibold "><u>Torna alla pagina di accesso</u></router-link>
                                    </form>
                                   
                                </div>
                            </div>
                        </div>
                        <!-- End Auth Box -->
                    </div>
                    <!-- End col -->
                </div>
                <!-- End row -->
            </div>
        </div>
        <!-- End Container -->
    </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ViewLogin',
  data() {
    return {
      user: {
        username: '',
        password: ''
      },
      errormessage: '',
      successmessage:''
    };
  },
  methods: {
      attemptLogin() {
          var me = this;
     me.successmessage = me.errormessage = "";
         
             axios.post('user/forgotpassword', {
                      username: me.user.username,
                      password:"xxxx"
                  }).then(response => {

                      if (response.status == 200 && !response.data.error) {
                          me.successmessage="Ti è stata inviata una mail contenente la password temporanea"
                      }
                      else {
                          me.errormessage = 'Email non registrata a sistema';
                      }


                  }) 
                  .catch(error => {
                      console.log(error);
                      this.error = 'Email non registrata a sistema';
                  });


          
     
    }
  }
};
</script>
